import {
  CatalogTaxRateResponse,
  StoreTaxOverrides,
  StoreTaxRateResponse,
} from '@interfaces/tax/1.0';
import { Observable } from 'rxjs';

export abstract class AbstractTaxService {
  abstract getAllTaxOverrides(storeId: string): Observable<StoreTaxOverrides>;

  abstract saveStoreDefaultTaxRate(
    storeId: string,
    taxRate: number,
  ): Observable<StoreTaxRateResponse>;

  abstract deleteStoreDefaultTaxRate(storeId: string): Observable<void>;

  abstract saveCatalogTaxRate(
    storeId: string,
    catalogEntryId: string,
    taxRate: number,
  ): Observable<CatalogTaxRateResponse>;

  abstract deleteCatalogTaxRate(storeId: string, catalogEntryId: string): Observable<void>;
}
